import { type InfiniteData, type QueryClient } from 'react-query'

import { type IInfinitePage } from 'types/interfaces/ITypes'

// const updatePostPinCache = async (
//     postId: string,
//     dataQuery: any,
//     queryClient: QueryClient
// ) => {
//     await queryClient.cancelQueries({ queryKey: dataQuery });

//     const cachedData =
//         queryClient.getQueryData<InfiniteData<IInfinitePage>>(dataQuery);

//     if (cachedData) {
//         const newData = {
//             ...cachedData,
//             pages: cachedData.pages.map(singleFeedPage => {
//                 let updatedPosts = singleFeedPage.page.data.data.map(post =>
//                     post.id === postId
//                         ? { ...post, is_pinned: !post.is_pinned, updated_at:post?.created_at } // Toggle pinned status
//                         : post
//                 );

//                 // Find the toggled post
//                 const toggledPost = updatedPosts.find(post => post.id === postId);
//                 if (!toggledPost) return singleFeedPage; // Safety check

//                 // Remove the toggled post from the list
//                 updatedPosts = updatedPosts.filter(post => post.id !== postId);

//                 if (toggledPost.is_pinned) {
//                     // If pinned, move it to the very top
//                     updatedPosts.unshift(toggledPost);
//                 } else {
//                     // If unpinned, place it after all pinned posts
//                     const pinnedPosts = updatedPosts.filter(post => post.is_pinned);
//                     const unpinnedPosts = updatedPosts.filter(post => !post.is_pinned);
//                     updatedPosts = [...pinnedPosts, toggledPost, ...unpinnedPosts];
//                 }

//                 return {
//                     ...singleFeedPage,
//                     page: {
//                         ...singleFeedPage.page,
//                         data: {
//                             ...singleFeedPage.page.data,
//                             data: updatedPosts
//                         }
//                     }
//                 };
//             })
//         };

//         queryClient.setQueryData(dataQuery, newData);
//     }

//     return { cachedData };
// };

const updatePostPinCache = async (
    postId: string,
    dataQuery: any,
    queryClient: QueryClient
) => {
    await queryClient.cancelQueries({ queryKey: dataQuery });

    const cachedData =
        queryClient.getQueryData<InfiniteData<IInfinitePage>>(dataQuery);

    if (cachedData) {
        const newData = {
            ...cachedData,
            pages: cachedData.pages.map(singleFeedPage => {
                let updatedPosts = singleFeedPage.page.data.data.map(post =>
                    post.id === postId
                        ? { ...post, is_pinned: !post.is_pinned } // Toggle pinned status
                        : post
                );

                // Find the toggled post
                const toggledPost = updatedPosts.find(post => post.id === postId);
                if (!toggledPost) return singleFeedPage; // Safety check

                // Remove the toggled post from the list
                updatedPosts = updatedPosts.filter(post => post.id !== postId);

                // Update the timestamp based on whether it's pinned or not
                toggledPost.updated_at = toggledPost.is_pinned 
                    ? new Date().toISOString() // If pinned, update timestamp
                    : toggledPost.created_at;  // If unpinned, revert to created_at

                // Add the toggled post back in the right place
                if (toggledPost.is_pinned) {
                    updatedPosts.unshift(toggledPost); // Pinned posts go to the top
                } else {
                    const pinnedPosts = updatedPosts.filter(post => post.is_pinned);
                    const unpinnedPosts = updatedPosts.filter(post => !post.is_pinned);
                    updatedPosts = [...pinnedPosts, toggledPost, ...unpinnedPosts];
                }


                // Sort all posts: pinned first, then by created_at descending
                updatedPosts.sort((a:any, b: any) => {
                    return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
                    // if (a.is_pinned === b.is_pinned) {
                    // }
                    // return b.is_pinned - a.is_pinned; // Pinned posts first
                });

                return {
                    ...singleFeedPage,
                    page: {
                        ...singleFeedPage.page,
                        data: {
                            ...singleFeedPage.page.data,
                            data: updatedPosts
                        }
                    }
                };
            })
        };

        queryClient.setQueryData(dataQuery, newData);
    }

    return { cachedData };
};



export { updatePostPinCache }
